"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24WarningTriangleFill = function Svg24WarningTriangleFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.07 3.275c-.197-.337-.409-.696-.614-.982-.212-.294-.6-.78-1.245-1.065a3 3 0 0 0-2.422 0c-.646.284-1.033.77-1.245 1.065-.205.286-.416.645-.614.982L1.66 15.63c-.203.345-.419.712-.57 1.035-.157.33-.399.917-.328 1.63a3 3 0 0 0 1.216 2.127c.58.423 1.208.511 1.571.545.356.032.781.032 1.182.032h14.536c.4 0 .826 0 1.182-.032.363-.034.991-.122 1.57-.545a3 3 0 0 0 1.217-2.126c.07-.714-.171-1.3-.327-1.63-.152-.324-.368-.69-.571-1.036L15.07 3.274zM13.28 6.8l-.4 8h-1.76l-.4-8h2.56zM12 18.16c-.72 0-1.28-.56-1.28-1.2 0-.64.56-1.2 1.28-1.2s1.28.56 1.28 1.2c0 .64-.56 1.2-1.28 1.2z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24WarningTriangleFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24WarningTriangleFill;
exports.default = _default;